import { gql } from 'graphql-request';

import {
  CategoryID,
  CategoryUUID,
  CategoryName,
  CategoryLocalizedName
} from '../../categories/categoriesTypes';

export interface FetchProductStylesQueryResponse {
  uuid: CategoryUUID;
  id: CategoryID;
  name: CategoryName;
  localizedName: CategoryLocalizedName;
}

export const FETCH_PRODUCT_STYLES_QUERY = gql`
  query ProductStylesCategories(
    $filters: CategoriesFilters
    $sort: [CategoriesSortEnum!]
    $limit: Int
    $offset: Int
  ) {
    categories(filters: $filters, sort: $sort, limit: $limit, offset: $offset) {
      nodes {
        uuid
        id
        name
        localizedName
      }
      sql
    }
  }
`;
